const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatenFehlenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "layer-1",
    viewBox: "0 0 500 372.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 327.45,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.83,
    y: 343.54,
    width: 53.07,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.56,
    y: 340.41,
    width: 58.66,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.2,
    y: 338.96,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.47,
    y: 335.94,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.46,
    y: 335.94,
    width: 15.44,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 340.16,
    width: 54.2,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,282.85H43.91a5.71,5.71,0,0,1-5.7-5.71V5.71A5.71,5.71,0,0,1,43.91.05H237a5.71,5.71,0,0,1,5.71,5.71h0V277.14A5.71,5.71,0,0,1,237,282.85ZM43.91.25a5.46,5.46,0,0,0-5.45,5.46V277.14a5.46,5.46,0,0,0,5.45,5.46H237a5.48,5.48,0,0,0,5.46-5.46V5.71A5.48,5.48,0,0,0,237,.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,282.85H260.21a5.73,5.73,0,0,1-5.71-5.71V5.71A5.72,5.72,0,0,1,260.21.05h193.1A5.71,5.71,0,0,1,459,5.71V277.14A5.7,5.7,0,0,1,453.31,282.85ZM260.21.25a5.48,5.48,0,0,0-5.46,5.46V277.14a5.48,5.48,0,0,0,5.46,5.46h193.1a5.48,5.48,0,0,0,5.46-5.46V5.71A5.48,5.48,0,0,0,453.31.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.65,
    y: 21.28,
    width: 43.83,
    height: 127.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.23,
    y: 21.28,
    width: 50.42,
    height: 127.93,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.46,
    y: 26.31,
    width: 41.97,
    height: 117.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.63,
    y: 39.33,
    width: 21.62,
    height: 91.83,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.64,
    y: 48.84,
    width: 43.83,
    height: 127.93,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.23,
    y: 48.84,
    width: 50.42,
    height: 127.93,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.45,
    y: 53.87,
    width: 41.97,
    height: 117.88,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.63,
    y: 66.89,
    width: 21.62,
    height: 91.83,
    rx: 8.64,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.82,
    y: 230.48,
    width: 8.51,
    height: 96.97,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.14,
    y: 230.48,
    width: 5.91,
    height: 96.97,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.31,
    y: 230.47,
    width: 101.2,
    height: 9.57,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.32,
    y: 240.04,
    width: 8.51,
    height: 87.4,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.63,
    y: 240.04,
    width: 5.91,
    height: 87.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.15,
    y: 240.04,
    width: 8.51,
    height: 87.4,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.47,
    y: 240.04,
    width: 5.91,
    height: 87.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.66,
    y: 240.04,
    width: 8.51,
    height: 87.4,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.97,
    y: 240.04,
    width: 5.91,
    height: 87.4,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.52,
    y: 230.48,
    width: 66.15,
    height: 9.57,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.25 230.27 404.68 230.27 410.05 171.27 366.62 171.27 361.25 230.27",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359 230.27 402.43 230.27 407.8 171.27 364.37 171.27 359 230.27",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.49 223.74 400.67 177.8 370.31 177.8 366.13 223.74 396.49 223.74",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.07,
    y: 30.71,
    width: 71.8,
    height: 296.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.94,
    y: 36.71,
    width: 58.06,
    height: 284.73,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.22,
    y: 30.71,
    width: 71.8,
    height: 296.73,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.02,
    y: 31.88,
    width: 3.05,
    height: 294.4,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.09,
    y: 36.71,
    width: 58.06,
    height: 284.73,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.97,
    y: 25.83,
    width: 165.15,
    height: 2.67,
    rx: 1.1,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.94,
    y: 36.72,
    width: 58.06,
    height: 5.67,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.93,
    y: 36.71,
    width: 58.06,
    height: 9.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.09,
    y: 36.71,
    width: 58.06,
    height: 20.89,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.800000011920929
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 190.74,
    y: 19.6,
    width: 11.08,
    height: 304.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.67,
    y: 19.6,
    width: 5.23,
    height: 304.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.69,
    y: 19.6,
    width: 11.08,
    height: 304.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.61,
    y: 19.6,
    width: 5.23,
    height: 304.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.23,
    y: 19.6,
    width: 11.08,
    height: 304.19,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.800000011920929
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.95,
    y: 19.6,
    width: 23.28,
    height: 304.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.1,
    y: 19.6,
    width: 10.99,
    height: 304.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.44,
    y: 19.6,
    width: 23.28,
    height: 304.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.59,
    y: 19.6,
    width: 10.99,
    height: 304.19,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.09,
    y: 19.6,
    width: 23.28,
    height: 304.19,
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 361.29,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.55,
    y: 115.7,
    width: 1,
    height: 18.56,
    transform: "translate(-9.58 6.68) rotate(-4.51)",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.07,
    y: 141.22,
    width: 1,
    height: 6.01,
    transform: "translate(-11.11 6.88) rotate(-4.52)",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.11 82.1 158.54 82.1 197.98 82.1 237.41 82.1 276.84 82.1 316.27 82.1 317.98 103.81 319.7 125.51 321.41 147.22 323.13 168.92 324.84 190.62 326.56 212.33 287.13 212.33 247.69 212.33 208.26 212.33 168.83 212.33 129.4 212.33 89.97 212.33 88.26 190.62 86.54 168.92 84.83 147.22 83.11 125.51 81.4 103.81 79.68 82.1 119.11 82.1",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.02 79.1 161.45 79.1 200.88 79.1 240.31 79.1 279.74 79.1 319.17 79.1 320.89 100.81 322.6 122.51 324.32 144.22 326.03 165.92 327.75 187.62 329.46 209.33 290.03 209.33 250.6 209.33 211.17 209.33 171.74 209.33 132.31 209.33 92.87 209.33 91.16 187.62 89.44 165.92 87.73 144.22 86.02 122.51 84.3 100.81 82.59 79.1 122.02 79.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.46 100.81 320.89 100.81 319.17 79.1 279.74 79.1 281.46 100.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.03 100.81 281.46 100.81 279.74 79.1 240.31 79.1 242.03 100.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.59 100.81 242.03 100.81 240.31 79.1 200.88 79.1 202.59 100.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.16 100.81 202.59 100.81 200.88 79.1 161.45 79.1 163.16 100.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.73 100.81 163.16 100.81 161.45 79.1 122.02 79.1 123.73 100.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.3 100.81 123.73 100.81 122.02 79.1 82.59 79.1 84.3 100.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.17 122.51 322.6 122.51 320.89 100.81 281.46 100.81 283.17 122.51",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.74 122.51 283.17 122.51 281.46 100.81 242.03 100.81 243.74 122.51",
    style: {
      fill: "#1188D8",
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.31 122.51 243.74 122.51 242.03 100.81 202.59 100.81 204.31 122.51",
    style: {
      fill: "#1188D8",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.88 122.51 204.31 122.51 202.59 100.81 163.16 100.81 164.88 122.51",
    style: {
      fill: "#1188D8",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.45 122.51 164.88 122.51 163.16 100.81 123.73 100.81 125.45 122.51",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.02 122.51 125.45 122.51 123.73 100.81 84.3 100.81 86.02 122.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.59,144.47H284.65v-.23l-1.74-22h39.93v.23Zm-39.47-.5h38.93l-1.68-21.21H283.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.46 144.22 284.89 144.22 283.17 122.51 243.74 122.51 245.46 144.22",
    style: {
      fill: "#1188D8",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.02 144.22 245.46 144.22 243.74 122.51 204.31 122.51 206.02 144.22",
    style: {
      fill: "#1188D8",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.59 144.22 206.02 144.22 204.31 122.51 164.88 122.51 166.59 144.22",
    style: {
      fill: "#1188D8",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.16 144.22 166.59 144.22 164.88 122.51 125.45 122.51 127.16 144.22",
    style: {
      fill: "#1188D8",
      opacity: 0.6000000238418579,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.73 144.22 127.16 144.22 125.45 122.51 86.02 122.51 87.73 144.22",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.3,166.17H286.37v-.23l-1.73-22h39.93v.23Zm-39.47-.5h38.93l-1.67-21.2H285.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.17 165.92 286.6 165.92 284.89 144.22 245.46 144.22 247.17 165.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.74 165.92 247.17 165.92 245.46 144.22 206.02 144.22 207.74 165.92",
    style: {
      fill: "#1188D8",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.31 165.92 207.74 165.92 206.02 144.22 166.59 144.22 168.31 165.92",
    style: {
      fill: "#1188D8",
      opacity: 0.800000011920929,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.88 165.92 168.31 165.92 166.59 144.22 127.16 144.22 128.88 165.92",
    style: {
      fill: "#1188D8",
      opacity: 0.800000011920929,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.44 165.92 128.88 165.92 127.16 144.22 87.73 144.22 89.44 165.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,187.87H288.08v-.23l-1.74-22h39.93v.23Zm-39.47-.5h38.93l-1.68-21.2H286.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.88 187.62 288.31 187.62 286.6 165.92 247.17 165.92 248.88 187.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.45 187.62 248.88 187.62 247.17 165.92 207.74 165.92 209.45 187.62",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "170.02 187.62 209.45 187.62 207.74 165.92 168.31 165.92 170.02 187.62",
    style: {
      fill: "#1188D8",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.59 187.62 170.02 187.62 168.31 165.92 128.88 165.92 130.59 187.62",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.16 187.62 130.59 187.62 128.88 165.92 89.44 165.92 91.16 187.62",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.73,209.58H289.8v-.23l-1.74-22H328v.23Zm-39.47-.5h38.93l-1.68-21.21H288.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.6 209.33 290.03 209.33 288.31 187.62 248.88 187.62 250.6 209.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.17 209.33 250.6 209.33 248.88 187.62 209.45 187.62 211.17 209.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.74 209.33 211.17 209.33 209.45 187.62 170.02 187.62 171.74 209.33",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.31 209.33 171.74 209.33 170.02 187.62 130.59 187.62 132.31 209.33",
    style: {
      fill: "#1188D8",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.87 209.33 132.31 209.33 130.59 187.62 91.16 187.62 92.87 209.33",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.16,101.05H281.23v-.23l-1.74-22h39.94v.23Zm-39.47-.5h38.93l-1.68-21.2H280Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.73,101.05H241.79v-.23l-1.74-22H280v.23Zm-39.47-.5h38.93l-1.68-21.2H240.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.3,101.05H202.36v-.23l-1.74-22h39.93v.23Zm-39.47-.5h38.93l-1.68-21.2H201.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.87,101.05H162.93v-.23l-1.73-22h39.93v.23Zm-39.48-.5h38.93l-1.67-21.2H161.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.43,101.05H123.5v-.23l-1.73-22H161.7v.23Zm-39.47-.5h38.93l-1.67-21.2H122.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,101.05H84.07v-.23l-1.73-22h39.93v.23Zm-39.47-.5h38.93l-1.67-21.2H82.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.17 122.51 322.6 122.51 320.89 100.81 281.46 100.81 283.17 122.51",
    style: {
      fill: "#1188D8",
      opacity: 0.10000000149011612,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.44,122.76H243.51v-.23l-1.73-22h39.93v.23Zm-39.47-.5H282.9l-1.67-21.21H242.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,122.76H204.08v-.23l-1.74-22h39.94v.23Zm-39.47-.5h38.93l-1.67-21.21H202.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.58,122.76H164.65v-.23l-1.74-22h39.94v.23Zm-39.47-.5H204l-1.64-21.21H163.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.15,122.76H125.21v-.23l-1.74-22H163.4v.23Zm-39.47-.5h38.93l-1.68-21.21H124Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.72,122.76H85.78v-.23l-1.74-22h40v.23Zm-39.47-.5h38.93l-1.68-21.21H84.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.59,144.47H284.65v-.23l-1.74-22h39.93v.23Zm-39.47-.5h38.93l-1.68-21.21H283.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.16,144.47H245.22v-.23l-1.74-22H283.4v.23Zm-39.47-.5h38.93l-1.68-21.21H244Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.73,144.47H205.79v-.23l-1.73-22H244v.23Zm-39.47-.5h38.92l-1.67-21.21H204.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.29,144.47H166.36v-.23l-1.73-22h39.93v.23Zm-39.47-.5h38.93l-1.67-21.21H165.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.86,144.47H126.93v-.23l-1.73-22h39.93v.23Zm-39.47-.5h38.93l-1.67-21.21H125.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.43,144.47H87.5v-.23l-1.73-22H125.7v.23ZM88,144h38.93l-1.68-21.21h-39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.3,166.17H286.37v-.23l-1.73-22h39.93v.23Zm-39.47-.5h38.93l-1.67-21.2H285.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.87,166.17H246.94v-.23l-1.74-22h39.94v.23Zm-39.47-.5h38.93l-1.68-21.2H245.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.44,166.17H207.51v-.23l-1.74-22h39.94v.23Zm-39.47-.5H246.9l-1.68-21.2H206.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,166.17H168.08v-.23l-1.74-22h39.94v.23Zm-39.47-.5h38.93l-1.68-21.2H166.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.58,166.17H128.64v-.23l-1.74-22h39.93v.23Zm-39.47-.5H168l-1.68-21.2H127.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.15,166.17H89.21v-.23l-1.74-22H127.4v.23Zm-39.47-.5h38.93l-1.68-21.2H88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,187.87H288.08v-.23l-1.74-22h39.93v.23Zm-39.47-.5h38.93l-1.68-21.2H286.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.59,187.87H248.65v-.23l-1.73-22h39.93v.23Zm-39.47-.5H288l-1.67-21.2H247.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.15,187.87H209.22v-.23l-1.73-22H247.4v.23Zm-39.47-.5h38.93l-1.67-21.2H208Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.72,187.87H169.79v-.23l-1.73-22H208v.23Zm-39.47-.5h38.93l-1.67-21.2H168.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.29,187.87H130.36v-.23l-1.73-22h39.93v.23Zm-39.47-.5h38.93l-1.67-21.2H129.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.86,187.87H90.93v-.23l-1.74-22h39.94v.23Zm-39.47-.5h38.93l-1.68-21.2H89.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.73,209.58H289.8v-.23l-1.74-22H328v.23Zm-39.47-.5h38.93l-1.68-21.21H288.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.3,209.58H250.37v-.23l-1.74-22h39.94v.23Zm-39.47-.5h38.93l-1.68-21.21H249.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,209.58H210.94v-.23l-1.74-22h39.94v.23Zm-39.47-.53h38.93l-1.68-21.21H209.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.44,209.58H171.5v-.23l-1.74-22h39.93v.23ZM172,209.05h38.9l-1.68-21.21H170.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,209.58H132.07v-.23l-1.74-22h39.93v.23Zm-39.47-.5h38.92l-1.67-21.21H130.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.58,209.58H92.64v-.23l-1.73-22h39.93v.23Zm-39.48-.53H132l-1.67-21.21H91.43Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.85,99.93A145.34,145.34,0,0,1,395,114.1a120.94,120.94,0,0,1,4.52,15l.42,2,.35,2,.17,1a12.91,12.91,0,0,1,.13,1.76,11,11,0,0,1-.09,1.62l-.1.77-.15.71a20,20,0,0,1-1.83,4.77,28.17,28.17,0,0,1-2.4,3.73,44.57,44.57,0,0,1-5.49,6,50.42,50.42,0,0,1-6.2,5,3.25,3.25,0,0,1-4.49-4.56l.1-.15A91.93,91.93,0,0,0,387.32,142a14.79,14.79,0,0,0,1.66-5.09v-.37a1,1,0,0,0,0-.24c0-.08-.06-.06-.06-.09l-.21-.8-.43-1.63-.5-1.65c-.32-1.1-.71-2.21-1.06-3.32s-.77-2.22-1.2-3.33c-.82-2.22-1.7-4.45-2.61-6.66-1.8-4.42-3.79-8.93-5.7-13.2l0-.11a6.5,6.5,0,0,1,11.74-5.57Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.19,154.46l-2.61,4.23a2.11,2.11,0,0,0,.72,2.9l.2.1,4.17,1.89a2.1,2.1,0,0,0,2.72-.93l1.13-2.12,2.92-4.81-3-4.64C379.8,151.05,377.19,154.46,377.19,154.46Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.88,350.19a2.41,2.41,0,0,1-1.88-.14.72.72,0,0,1-.18-.84.83.83,0,0,1,.47-.53c1-.49,3.38.47,3.48.52a.16.16,0,0,1,.11.16.14.14,0,0,1-.1.16A8.59,8.59,0,0,1,405.88,350.19ZM404.64,349a.86.86,0,0,0-.21.07.49.49,0,0,0-.27.31c-.1.32,0,.42.06.45.41.35,1.93,0,3-.4a6,6,0,0,0-2.58-.43Z",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.73,349.58h-.09c-.86-.25-2.7-1.55-2.72-2.41a.61.61,0,0,1,.46-.59,1,1,0,0,1,.8.07c1,.52,1.66,2.62,1.69,2.71a.2.2,0,0,1-.05.18Zm-2.15-2.69h-.08c-.22.08-.22.19-.22.24,0,.51,1.23,1.53,2.12,1.95a4.24,4.24,0,0,0-1.38-2.14.61.61,0,0,0-.44-.05Z",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.14,353.92c-1,0-1.91-.14-2.23-.58a.66.66,0,0,1,0-.78.87.87,0,0,1,.57-.42c1.26-.35,3.92,1.17,4,1.23a.2.2,0,0,1,.09.19.17.17,0,0,1-.14.14A13.56,13.56,0,0,1,351.14,353.92Zm-1.2-1.48h-.35a.52.52,0,0,0-.35.26c-.13.22-.08.33,0,.39.36.49,2.28.51,3.69.31a7.89,7.89,0,0,0-3-1Z",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.44,353.71h-.07c-.92-.41-2.74-2.06-2.6-2.91,0-.21.18-.46.67-.51a1.31,1.31,0,0,1,1,.31c1,.8,1.17,2.84,1.18,2.93a.16.16,0,0,1-.07.16A.14.14,0,0,1,353.44,353.71Zm-1.85-3.09h-.11c-.33,0-.35.16-.35.2-.09.52,1.15,1.81,2.08,2.37a4.15,4.15,0,0,0-1-2.34A1,1,0,0,0,351.59,350.62Z",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.8 353.52 354.2 353.52 353.44 335.92 361.04 335.92 361.8 353.52",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.2 347.56 408.77 349.17 401.32 332.77 408.75 331.16 416.2 347.56",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.06,348.42l8.35-1.81a.68.68,0,0,1,.74.38l2.9,6.28a1.11,1.11,0,0,1-.56,1.48,1.13,1.13,0,0,1-.24.08c-2.93.58-4.38.71-8.05,1.51-2.26.49-7.36,1.73-10.48,2.41s-4.19-2.33-3-2.88c5.45-2.49,7.73-4.69,9.2-6.73A1.88,1.88,0,0,1,408.06,348.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.25,352.65h8.3a.66.66,0,0,1,.65.52l1.5,6.75a1.11,1.11,0,0,1-.84,1.32,1.15,1.15,0,0,1-.26,0c-3,0-7.32-.22-11.08-.22-4.4,0-8.2.24-13.36.24-3.13,0-4-3.16-2.69-3.44,5.95-1.3,10.81-1.44,15.95-4.61A3.43,3.43,0,0,1,354.25,352.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.44 335.93 353.83 345 361.44 345 361.05 335.93 353.44 335.93",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.75 331.16 401.32 332.77 405.17 341.22 412.6 339.62 408.75 331.16",
    style: {
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.36,160.16s8.64,58.1,13.36,79.89c5.19,23.84,31.61,100.24,31.61,100.24l13.61-3s-19.45-71.53-22.41-95.13c-3.22-25.61-9.94-82-9.94-82Z",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.07,335.72c-.06,0,2.54,4.92,2.54,4.92l15.31-3.32-1.29-4.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.81,180.86c10,2,8.92,39.16,7.72,58.29-2.88-13.52-7.09-39.55-10-58A3.39,3.39,0,0,1,361.81,180.86Z",
    style: {
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.94,160.16s-1.05,56.84-.22,80c.86,24.11,9.28,103.06,9.28,103.06h12.88s.47-77.54,1-101.22c.63-25.81,3.74-81.86,3.74-81.86Z",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.52,338.11c-.06,0,.73,5.35.73,5.35h15.66l.42-4.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.52,71.82c13.55-3.42,28.51,4.5,33.41,17.68s-2.13,26.64-15.68,30.06-28.51-4.49-33.41-17.68S264,75.24,277.52,71.82Zm16.33,44c11.4-2.88,17.31-14.21,13.19-25.3s-16.71-17.76-28.12-14.88-17.32,14.21-13.2,25.3a24.35,24.35,0,0,0,28.13,14.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.22,114.1c10.46-2.64,15.87-13,12.1-23.19a22.3,22.3,0,0,0-25.77-13.63c-10.45,2.64-15.88,13-12.1,23.19A22.32,22.32,0,0,0,293.22,114.1Z",
    style: {
      fill: "#1188D8",
      opacity: 0.20000000298023224,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.65,119.26a58.22,58.22,0,0,0,1.64,5.85c.64,1.93,1.3,3.85,2,5.75s1.49,3.8,2.28,5.68c1,1.84,1,3.93,4.07,5.23a3,3,0,0,0,2.83-.43,1.59,1.59,0,0,0,.34-.39c1.42-2.46-.24-4.12-.94-6-.87-1.86-1.78-3.72-2.71-5.57s-1.94-3.68-3-5.5-2.14-3.63-3.37-5.4a2,2,0,0,0-2.15-.37C293,118.33,292.55,118.82,292.65,119.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.56,71.83c.16.59,0,1.15-.43,1.25s-.82-.3-1-.9,0-1.15.43-1.25S347.41,71.23,347.56,71.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,73a21.92,21.92,0,0,1-1.55,5.8,3.51,3.51,0,0,0,3-.19Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.9,68a.29.29,0,0,0,.18-.19.36.36,0,0,0-.2-.46,3.56,3.56,0,0,0-3.28.25.38.38,0,0,0-.09.51.37.37,0,0,0,.51.08h0a2.82,2.82,0,0,1,2.59-.17A.36.36,0,0,0,348.9,68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,74.7c.72,5.78,1.24,12,4.48,16.81,0,0,.1,5.65-10.19,6.58-11.32,1-7-5-7-5,4.14-1,4.28-6.49,2-10.63Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.89,95.05c.64-2.54,1.33-5.45-.6-6.21-2.12-.83-13.41-1-17.15,1.1S353.86,97,353.86,97Z",
    style: {
      fill: "#1188D8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,94.05c7,2,12.41,20.65,12.41,20.65l-16.33,8A160,160,0,0,1,375,107.84C371.71,98.55,377.79,92.05,385,94.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4000000059604645
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.16,
    y: 100.3,
    width: 6.86,
    height: 1,
    transform: "translate(134.6 407.33) rotate(-66.39)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.86,96.87l-1.12,2.57.91.4.92-2.1C389.34,97.44,389.1,97.15,388.86,96.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.45,
    y: 111.27,
    width: 6.86,
    height: 1,
    transform: "translate(127.12 417.84) rotate(-66.39)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.62,107.05c-.17-.41-.35-.84-.54-1.26l-2,4.67.92.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.53,99.05c-1.82,7-3.65,23.65,1.41,61.08,17.29,1.77,33.13,2.84,40.65,0,.34-7.45-3.46-37.54,2.38-66.09a105.47,105.47,0,0,0-13.61-1.72,146.5,146.5,0,0,0-17.28,0,70.07,70.07,0,0,0-7.75,1.19A7.56,7.56,0,0,0,340.53,99.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4000000059604645
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.1,94.05l.87.5.93-1.64-1.27.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.56,
    y: 105.28,
    width: 6.86,
    height: 1,
    transform: "translate(81.01 350.8) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.93,
    y: 102.16,
    width: 6.86,
    height: 1,
    transform: "translate(89.43 359.06) rotate(-60.37)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.82,
    y: 98.08,
    width: 6.85,
    height: 1,
    transform: "translate(99.09 366.7) rotate(-60.61)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.66,
    y: 95.89,
    width: 6.86,
    height: 1,
    transform: "translate(106.42 375.69) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.7,
    y: 116.66,
    width: 6.86,
    height: 1,
    transform: "translate(72.66 359.24) rotate(-60.37)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.63,
    y: 112.52,
    width: 6.85,
    height: 1,
    transform: "translate(82.34 366.92) rotate(-60.61)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.95,
    y: 109.4,
    width: 6.85,
    height: 1,
    transform: "translate(90.82 375.2) rotate(-60.61)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.81,
    y: 107.28,
    width: 6.86,
    height: 1,
    transform: "translate(98.11 384.19) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,128.87a.67.67,0,0,1,0,.2l.09-.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.81,
    y: 128.02,
    width: 6.86,
    height: 1,
    transform: "translate(64.4 367.73) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.17,
    y: 124.88,
    width: 6.86,
    height: 1,
    transform: "translate(72.87 376.02) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.54,
    y: 121.75,
    width: 6.86,
    height: 1,
    transform: "translate(81.34 384.32) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.22,121.88l.87.5.79-1.39c0-.73.07-1.47.11-2.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.12,140.29l-.86-.49-1.39,2.44c.05.57.1,1.14.16,1.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.94,
    y: 139.4,
    width: 6.86,
    height: 1,
    transform: "translate(56.09 376.21) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.31,
    y: 136.27,
    width: 6.86,
    height: 1,
    transform: "translate(64.56 384.51) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.67,
    y: 133.12,
    width: 6.86,
    height: 1,
    transform: "translate(73.04 392.79) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.38,151.17l-2.94,5.18a8.42,8.42,0,0,0,.14,1.11l.28.16,3.39-6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.08,
    y: 150.8,
    width: 6.86,
    height: 1,
    transform: "translate(47.77 384.7) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.45,
    y: 147.67,
    width: 6.86,
    height: 1,
    transform: "translate(56.24 393) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.81,
    y: 144.5,
    width: 6.86,
    height: 1,
    transform: "translate(64.74 401.28) rotate(-60.38)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.75,159.91l-.87-.5-1.2,2.12,1.11.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.12,156.78l-.87-.49-3.19,5.61h1.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,153.75v-.13l-.81-.46-3.39,6,.87.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M340.27,100.17h0c6.72-6.15,9.1,5.4,8.69,10.59-1.16,14.39-9.49,19.12-10,19.55C338.12,114.31,339.13,105.2,340.27,100.17Z",
    style: {
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.74,106.83c-1.72,2.26-3.5,4.53-5.27,6.77l-5.35,6.72-5.36,6.73c-1.76,2.24-3.55,4.45-5.26,6.67l-.39.5a4.93,4.93,0,0,1-3.22,1.87c-2,.27-4,.46-5.91.54s-3.9.08-5.83,0-3.85-.24-5.76-.49a51.21,51.21,0,0,1-5.75-1,3.27,3.27,0,0,1,.25-6.4h.16l5.23-.87q2.63-.44,5.21-.93c1.72-.31,3.42-.69,5.1-1s3.31-.82,4.92-1.24L319.9,127c3.21-5,6.55-9.75,10-14.44,1.71-2.35,3.47-4.66,5.24-7s3.57-4.57,5.44-6.81a6.5,6.5,0,1,1,10.19,8.08Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.64,128.05l-4.71,1.59a2.1,2.1,0,0,0-1.32,2.66,2.6,2.6,0,0,0,.1.25l2,4.12a2.1,2.1,0,0,0,2.69,1l2.22-.91,5.32-1.83.68-5.46C303.83,127.05,299.64,128.05,299.64,128.05Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.21,100.05c2.93,10.06-12.44,24-12.44,24L328,110.5s4.55-5.67,7.75-9.41C344.68,90.62,351.88,92,354.21,100.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4000000059604645
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.13,94c-.39.12-.78.26-1.16.42L343.52,96l1,.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.05 113.52 331.6 111.55 330.64 111.28 330.24 112.72 331.05 113.52",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.04,
    y: 108.39,
    width: 6.86,
    height: 1,
    transform: "translate(144.39 407.77) rotate(-74.47)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.82,
    y: 104.41,
    width: 6.84,
    height: 1,
    transform: "translate(155.15 414.63) rotate(-74.29)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.67,116.05l-1-.26-1.25,4.49q.74-.82,1.53-1.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M367.07,65.53c1.4,7.42,2.6,11.68-.13,16.36-4.12,7-14,6-17.57-.85-3.23-6.16-5-17.25,1.42-22a10.28,10.28,0,0,1,16.28,6.49Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.39,72.27c-3.78-.28-3.48-6-1.32-8-5.46-.22-12.3-.44-10.63-6.39,1.23-4.33,12.67-4.44,7.34-7.44,5.11-3.17,8.14,2.11,5.63,3.28,8-3.11,17.2-5.34,13.92,2.33,5.5-.89,9.28,8.24,6.45,12.18s2.1,4.65,2.89,2.82c.39,5.33-5.06,5.17-5.84,4.17,3.28,5-3.33,11.27-10.05,7.89S352.39,72.27,352.39,72.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.16,56.55c4.25-2.42,5-5.46,3.29-8.34C375.49,50.63,371.05,57.05,365.16,56.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.54,71.05a7.13,7.13,0,0,1-.42,4.62c-.87,1.91-2.56,1.43-3.37-.29-.73-1.55-1.16-4.4.22-5.74S355.07,69.2,355.54,71.05Z",
    style: {
      fill: "#ce7a63"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatenFehlenIcon);
export default __webpack_public_path__ + "static/media/Daten_Fehlen_icon.b5471603e33c7a7ad76f32676597d04f.svg";
export { ForwardRef as ReactComponent };